import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { AssetPlan, AssetPlanPin, PlanContent, PlanDetails } from '@models';
import { forkJoin, map, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class PlansService {
  private _http = inject(HttpClient);

  fetchPlans(): Observable<AssetPlan[]> {
    return this._http.get<AssetPlan[]>(`/maps`);
  }

  fetchPlanPins(planId: number): Observable<AssetPlanPin[]> {
    return this._http.get<AssetPlanPin[]>(`/maps/${planId}/pins`);
  }

  fetchPlanContent(planId: number): Observable<PlanContent> {
    return this._http.get<PlanContent>(`/maps/${planId}/file`);
  }

  fetchPlanDetails(planId: number): Observable<PlanDetails> {
    return forkJoin([
      this.fetchPlanContent(planId),
      this._http.get<AssetPlan>(`/maps/${planId}`),
    ]).pipe(
      map(([{ content }, plan]) => ({
        ...plan,
        content,
      }))
    );
  }

  deletePlan(planId: number): Observable<void> {
    return this._http.delete<void>(`/maps/${planId}`);
  }

  uploadPlan(plan: File): Observable<AssetPlan> {
    const formData = new FormData();
    formData.append('mapFile', plan);
    return this._http.post<AssetPlan>('/maps', formData);
  }

  savePlanPin(pin: AssetPlanPin, planId: number): Observable<AssetPlanPin> {
    if (pin.id) {
      return this._http.put<AssetPlanPin>(
        `/maps/${planId}/pins/${pin.id}`,
        pin
      );
    }

    return this._http.post<AssetPlanPin>(`/maps/${planId}/pins`, pin);
  }

  deletePlanPin(pin: AssetPlanPin, planId: number): Observable<void> {
    return this._http.delete<void>(`/maps/${planId}/pins/${pin.id}`);
  }
}
